module.exports = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIyMCIgaGVpZ2h0PSIxNyIgdmlld0JveD0iMCAwIDI0IDIwIiBmb2N1c2FibGU9ImZhbHNlIj4KICAgIDxwYXRoIGZpbGw9IiNGRjAwMDAiIGQ9Ik0xNS4xLDBIMjR2MjBMMTUuMSwweiBNOC45LDBIMHYyMEw4LjksMHogTTEyLDcuNEwxNy42LDIwaC0zLjhsLTEuNi00SDguMUwxMiw3LjR6Ij48L3BhdGg+Cjwvc3ZnPg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/logos/adobe.svg
// module id = YCA1
// module chunks = 1